import React from 'react';
import styled from 'styled-components';

import GuideSection from '../../shared/guideSection/GuideSection';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import { ExtendedBackgroundContainer } from '../../../atoms/extendedBackgroundContainer/ExtendedBackgroundContainer';

const StrapiContent = styled.div`
  h2 {
    font-size: 1.75rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }
  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
  }
  h4 {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
  }
  p {
    margin-bottom: 2rem;
    font-weight: 300;
  }
  ul {
    list-style-type: disc;
    padding-left: 2rem;
    margin-bottom: 2rem;
    font-weight: 300;

    li {
      margin-bottom: 1rem;
    }
  }
  ol {
    list-style-type: decimal;
    padding-left: 2rem;
    margin-bottom: 2rem;
    font-weight: 300;

    li {
      margin-bottom: 1rem;
    }
  }
`;

const SystemGuideSection = ({ section }) => (
  <div>
    <ExtendedBackgroundContainer />
    <GuideSection
      shortTitle={section.label}
      section={section}
      customContent={
        <Stack className="gap-6">
          {section.componentData.strapiText && (
            <StrapiContent
              dangerouslySetInnerHTML={{
                __html: section.componentData.strapiText,
              }}
            />
          )}
          {section.componentData.text1 && (
            <Typography
              fontVariant="lg"
              className="!text-customGray-600"
              textAlign="left"
              dangerouslySetInnerHTML={{ __html: section.componentData.text1 }}
            />
          )}
          {section.componentData.text2 && (
            <Typography
              fontVariant="lg"
              className="!text-customGray-600"
              textAlign="left"
              dangerouslySetInnerHTML={{ __html: section.componentData.text2 }}
            />
          )}
          {section.componentData.text3 && (
            <Typography
              fontVariant="lg"
              className="!text-customGray-600"
              textAlign="left"
              dangerouslySetInnerHTML={{ __html: section.componentData.text3 }}
            />
          )}

          <LinkButton
            className="w-fit mt-3"
            size="button"
            variant="primary-filled"
            textTransform="uppercase"
            href={section.actionButtonHref}
            label={section.actionButtonText}
            onClick={section.onActionButtonClick}
          />
        </Stack>
      }
    />
  </div>
);

export default SystemGuideSection;
